import {ROUTES} from '@/router/routes'

export const PLATFORM = 'mp'

export const SECTION_ROUTES = {
    app: ROUTES.home,
    overview: ROUTES.home,
    pos_payments: ROUTES.posPayments,
    online_payments: ROUTES.onlinePayments,
    payment_links: ROUTES.paymentLinks,
    virtual_terminal: ROUTES.virtualTerminal,
    pos_american_express: ROUTES.posAmexPayments,
    // settlements: ROUTES.settlements,
    invoices: ROUTES.billing.invoices,
    reports: ROUTES.reports,
    payment_methods: ROUTES.settings.paymentMethods,
    team_management: ROUTES.settings.teamManagement,
    exports: ROUTES.exports,
    login: ROUTES.login,
    profile: ROUTES.profile,
    chargebacks: ROUTES.chargebacks,
    zash_epos: ROUTES.zashEpos,
    digital_receipts: ROUTES.digitalReceipts,
    dcc: ROUTES.dcc,
    ['merchant.profile']: ROUTES.settings.companyProfile,
    ['merchant.bank_accounts']: ROUTES.settings.bankAccounts,
    ['merchant.pos_outlets']: ROUTES.settings.posOutlets,
    ['merchant.online_outlets']: ROUTES.settings.onlineOutlets,
    ['settlements.per_transaction_date']: ROUTES.settlements.perTransactionDate,
    ['settlements.per_settlement_date']: ROUTES.settlements.perSettlementDate,
}
